import { render, staticRenderFns } from "./hr_bussiness_config.vue?vue&type=template&id=31520921&scoped=true"
import script from "./hr_bussiness_config.vue?vue&type=script&lang=js"
export * from "./hr_bussiness_config.vue?vue&type=script&lang=js"
import style0 from "./hr_bussiness_config.vue?vue&type=style&index=0&id=31520921&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31520921",
  null
  
)

export default component.exports